import React, { useState, useEffect } from 'react';
import { Modal, Button, Row, Col } from "react-bootstrap";
import ColouredText from '../../components/ColouredText';

const PlayerDescriptionCreate = ({ showModal, hideModal, createDescription, descriptionType }) => {

    const [descriptionId, setDescriptionId] = useState('NEW');
    const [description, setDescription] = useState('');
    const [descriptionLength, setDescriptionLength] = useState(0);
    const [disableSave, setDisableSave] = useState(false);

    useEffect(() => {
        setDescription('');
        setDescriptionId('');
    }, [showModal]);

    useEffect(() => {
        setDescriptionLength(description.length);
    }, [description]);

    function isValid(str) { return /^\w+$/.test(str); }

    const handleChange = (e) => {
        setDescription(e.target.value);
        setDescriptionLength(e.target.value.length);
    }

    const handleIdChange = (e) => {
        setDescriptionId(e.target.value.toUpperCase());
        setDisableSave(!isValid(e.target.value));
    }

    let rows = 3;
    if (descriptionType !== 0) {
        rows = 20;
    }

    return (
        <Modal size="xl" show={showModal} onHide={hideModal}>
            <Modal.Header closeButton>
                <Modal.Title>Create Desc</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col xs lg="3">
                        <span>Id</span>
                    </Col>
                    <Col lg>
                        <textarea className="eomEditor my-2 p-2 eom-box" value={descriptionId} onChange={e => handleIdChange(e)} rows={rows}></textarea>
                    </Col>
                </Row>

                <Row>
                    <Col xs lg="3">
                        <span>Description</span>
                    </Col>
                    <Col lg>
                        <ColouredText ColouredText={description} />
                    </Col>
                </Row>

                <Row>
                    <Col xs lg="3">
                        <span>Enter Raw Text</span>
                    </Col>
                    <Col lg>
                        <textarea className="eomEditor my-2 p-2 eom-box" value={description} onChange={e => handleChange(e)} rows={rows}></textarea>
                    </Col>
                </Row>
                <Row>
                    <Col xs lg="3">
                    </Col>
                    <Col lg>
                        <small>{descriptionLength} characters</small>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button disabled={disableSave} onClick={() => createDescription(descriptionId, description)}>Create </Button>
                <Button onClick={() => hideModal()}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default PlayerDescriptionCreate;